// extracted by mini-css-extract-plugin
export var fullSize = "components-fullSize--KDoGT";
export var fullViewportHeight = "components-fullViewportHeight--SVmig";
export var hero = "components-hero--JreNK";
export var heroDetails = "components-heroDetails--xCojk";
export var heroHeadline = "components-heroHeadline--j56rL";
export var heroImage = "components-heroImage--NL-O0";
export var heroTitle = "components-heroTitle--UcXZX";